const initialState = {
    invoiceFilesList: [],
    loading: false,
    message: null,
    error: null,
    invoiceDetailedData: []
};
  
  const invoiceFilesReducer = (state = initialState, action) => {
    console.log("action.type", action.type);
    switch (action.type) {
      case 'GET_INVOICE_FILES':
        return {
          ...state,
          invoiceFilesList: action.payload,
        };
      case 'UPLOAD_INVOICE_FILE':
        return {
          ...state,
          loading: true,
        };
      case 'UPLOAD_INVOICE_FILE_SUCCESS':
        return {
          ...state,
          message: 'Completed',
        };
      case 'UPLOAD_INVOICE_FILE_FAILURE':
        return {
          ...state,
          error: 'error',
        };
        /**
         * 
         */
      case 'DOWNLOAD_PRODUCT_REPORT_START':
        return {
          loading: true,
          message: 'Descargando...',
          ...state
        };

      case 'DOWNLOAD_PRODUCT_REPORT':
        return {
          loading: false,
          message: 'Descarga completa',
          ...state
        };
        case 'DOWNLOAD_PRODUCT_REPORT_FAILURE':
          return {
            loading: false,
            message: 'Error',
            ...state
          };
      
      case 'GET_PRODUCT_DETAIL_REPORT': {
        console.log("no sirve");
        let hola =  {
          loading: true,
          invoiceDetailedData: action.payload,
          message: 'Error',
          ...state
        };
        console.log("hola", hola);
        return hola
      }
          
    
      // Otros casos para otras acciones
      default:
        return state;
    }
  };
  
  export default invoiceFilesReducer;